import overviewMdx from './page.mdx';
import howPaymentsWorkMdx from './how-payments-work/page.mdx';
import authenticationMdx from './authentication/page.mdx';
import signaturesMdx from './signatures/page.mdx';
import testingMdx from './testing/page.mdx';
import createPaymentMdx from './api/create-payment/page.mdx';
import getPaymentStatusMdx from './api/get-payment-status/page.mdx';
import cancelPaymentMdx from './api/cancel-payment/page.mdx';
import refundsMdx from './api/refunds/page.mdx';
import webhookMdx from './api/webhook/page.mdx';

export const DOCS_SECTIONS = [
  {
    title: "General",
    items: [
      { id: "overview", name: "Overview", path: "/overview" },
      { id: "how-payments-work", name: "How Payments Work", path: "/how-payments-work" },
      { id: "authentication", name: "Authentication", path: "/authentication" },
      { id: "signatures", name: "Signature Validation", path: "/signatures" },
      { id: "testing", name: "Testing", path: "/testing" },
    ],
  },
  {
    title: "API Reference",
    items: [
      { id: "create-payment", name: "Create Payment Link", path: "/api/create-payment" },
      { id: "get-payment-status", name: "Get Payment Status", path: "/api/get-payment-status" },
      { id: "cancel-payment", name: "Cancel Payment", path: "/api/cancel-payment" },
      { id: "refunds", name: "Refunds", path: "/api/refunds" },
      { id: "webhook", name: "Webhook Notification", path: "/api/webhook" },
    ],
  },
];

export const DOCS_FILES = {
  overview: overviewMdx,
  "how-payments-work": howPaymentsWorkMdx,
  authentication: authenticationMdx,
  signatures: signaturesMdx,
  testing: testingMdx,
  "create-payment": createPaymentMdx,
  "get-payment-status": getPaymentStatusMdx,
  "cancel-payment": cancelPaymentMdx,
  refunds: refundsMdx,
  webhook: webhookMdx,
};

// Aliased for components expecting DOCS_CONTENT
export const DOCS_CONTENT = DOCS_FILES;
